import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Selector reutilizable de temporadas.
 * - Se autopopula desde /seasons (una sola vez por montaje).
 * - Por defecto selecciona la temporada activa (is_current).
 * - Notifica cambios vía onChange(nombre).
 *
 * Props:
 *   value: string  → nombre de la temporada seleccionada
 *   onChange: (name) => void
 *   includeAll: boolean → añade opción "Todas"
 *   size: "sm" | "md" (default "md")
 *   testid: string
 */
export default function SeasonSelector({ value, onChange, includeAll = true, size = "md", testid = "season-selector" }) {
  const [seasons, setSeasons] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/seasons");
        if (cancelled) return;
        setSeasons(data || []);
        // Si no hay valor definido aún, aplicar la activa
        if (!value && Array.isArray(data)) {
          const active = data.find((s) => s.is_current);
          if (active && onChange) onChange(active.name);
        }
      } catch (e) {
        // Silencioso: si falla, dejamos vacío
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const h = size === "sm" ? "h-9 text-xs" : "h-11 text-sm";

  return (
    <select
      data-testid={testid}
      value={value || ""}
      onChange={(e) => onChange && onChange(e.target.value)}
      className={`bg-white border border-slate-200 px-3 ${h} focus:border-[#2563EB] outline-none`}
      style={{ borderRadius: 6, minWidth: 160 }}
      disabled={!loaded}
    >
      {includeAll && <option value="">Todas las temporadas</option>}
      {seasons.map((s) => (
        <option key={s.id} value={s.name}>
          {s.name}{s.is_current ? " ★" : ""}{s.status === "cerrada" ? " (cerrada)" : ""}
        </option>
      ))}
    </select>
  );
}
